<template>
  <ife-row
    v-if="hasCompanyLogin"
    align-h="center"
  >
    <ife-col
      :class="'mt-4' + (hasCompanyLogin ? ' text-' + align : '')"
    >
      <img
        v-if="hasCompanyLogo"
        id="companyLogo"
        alt="Company Logo"
        :class="companyCssClass"
        :src="getCompanyLogo"
        :style="`padding-top: ${paddingTop}; padding-bottom: ${paddingBottom}; width: ${logoWidth}`"
      >
    </ife-col>
  </ife-row>
</template>

<script>
import CompanyLoginMixin from '@/Client/Mixin/CompanyLogin';

export default {
  name: 'ShowcaseCompanyLogo',
  mixins: [CompanyLoginMixin],
  props: {
    align: {
      type: String,
      default: 'center',
    },
    paddingTop: {
      type: String,
      default: '70px',
    },
    paddingBottom: {
      type: String,
      default: '50px',
    },
    width: {
      type: String,
      default: null,
    },
  },
  data() {
    return {

    };
  },
  computed: {
    getCompanyLogo() {
      return require(
          '../../assets/img/logo/' +
          this.companyLogin.logo,
      );
    },
    hasCompanyLogo() {
      return this.hasCompanyLogin && this.companyLogin.hasOwnProperty('logo');
    },
    logoWidth() {
      if (!this.hasCompanyLogo) {
        return 0;
      }

      const logoWidth = this.companyLogin.logoWidth ?? 0;

      return (this.width ? this.width : (logoWidth > 0 ? logoWidth : '300px'));
    },
  },
};
</script>

<style scoped>

</style>
